import { createStore } from 'owa-satcheljs';
import type { ChatAnswer } from 'owa-search-copilot-answer-shared';

export interface CopilotSearchAnswerStoreSchema {
    chatAnswer: ChatAnswer | undefined;
    isLoading: boolean;
    currentQuery: string | undefined;
    isScrollMinimized: boolean;
    hasManuallyTriggered: boolean;
    executedSearchQuery: string;
    // Immutable IDs of the top results of the most recent search, kept so retries of that search
    // stay grounded.
    overviewMessageIds: { searchNumber: number; messageIds: string[] } | undefined;
}

const initialState: CopilotSearchAnswerStoreSchema = {
    chatAnswer: undefined,
    isLoading: false,
    currentQuery: undefined,
    isScrollMinimized: false,
    hasManuallyTriggered: false,
    executedSearchQuery: '',
    overviewMessageIds: undefined,
};

const store: () => CopilotSearchAnswerStoreSchema = createStore<CopilotSearchAnswerStoreSchema>(
    'copilotSearchAnswerStore',
    initialState
);

export default store;
export const getStore: () => CopilotSearchAnswerStoreSchema = store;
